// extracted by mini-css-extract-plugin
export default {"App":"InputForms_App__+8H6o","search":"InputForms_search__qSel8","searchInput":"InputForms_searchInput__UxjmO","search__icon":"InputForms_search__icon__XZTss"};